import { Link } from 'react-router-dom';
import { DataTable } from '../../../../components';
import { Leg } from '../../interfaces';

interface Props {
  data: Leg[];
  page: number;
  onChangePage: (newPage: number) => void;
  pageSize: number;
  onChangePageSize: (newPageSize: number) => void;
  count: number;
  pages: number;
  loading: boolean;
  isAdmin: boolean;
}

export default function LegsHistoryDataTable({
  data,
  page,
  onChangePage,
  pageSize,
  onChangePageSize,
  count,
  pages,
  loading,
  isAdmin,
}: Props) {
  const headers = [
    {
      key: 'date',
      text: 'Date',
      getCellContent: (value: string) => value,
      noWrap: true,
    },
    {
      key: 'legNumber',
      text: 'Leg #',
      getCellContent: (value: string) => value,
      noWrap: true,
    },
    {
      key: 'carrierName',
      text: 'Carrier',
      getCellContent: (value: string) => value,
    },
    {
      key: 'service',
      text: 'Service',
      getCellContent: (value: string) => value,
    },
    {
      key: 'routing',
      text: 'Routing',
      getCellContent: (value: string) => value,
    },
    {
      key: 'tracking',
      text: 'Tracking',
      getCellContent: (value: string) => value,
      noWrap: true,
    },
    {
      key: 'pickup',
      text: 'Pickup',
      getCellContent: (value: string) => value,
      noWrap: true,
    },
    {
      key: 'legNumber',
      text: '',
      getCellContent: (legNumber: string) => {
        const shipmentId = legNumber.substring(0, legNumber.length - 3);
        return (
          <Link
            className='text-decoration-none'
            to={`/app/${isAdmin ? 'admin/' : ''}shipment-history/view?shipment_id=${shipmentId}`}
          >
            <div className='labelText'
              style={{ color: '#251163', fontSize: '16px'}}
            >
              Details
            </div>
          </Link>
        );
      }
    },
  ]

  return (
    <div className='LegHistoryDataTable'>
      <DataTable
        headers={headers}
        data={data}
        page={page}
        onChangePage={onChangePage}
        pageSize={pageSize}
        onChangePageSize={onChangePageSize}
        count={count}
        pages={pages}
        loading={loading}
      />
    </div>
  );
}
